module.exports = __webpack_public_path__ + "img/257.69d0a9d4.png";